"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var UnsavedChangesModal_1 = __importDefault(require("../UnsavedChangesModal"));
var BlockLeavePage = function (_a) {
    var isBlock = _a.isBlock, modalTitle = _a.modalTitle, modalDescription = _a.modalDescription, primaryButtonLabel = _a.primaryButtonLabel, secondaryButtonLabel = _a.secondaryButtonLabel, onCancel = _a.onCancel, onLeave = _a.onLeave;
    var navigator = (0, react_1.useContext)(react_router_dom_1.UNSAFE_NavigationContext).navigator;
    var _b = (0, react_1.useState)(false), isShowConfirm = _b[0], setIsShowConfirm = _b[1];
    var pushRef = (0, react_1.useRef)(navigator.push);
    var pushArgsRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        if (isBlock) {
            window.onbeforeunload = function () {
                return true;
            };
            navigator.push = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                pushArgsRef.current = args;
                setIsShowConfirm(true);
            };
        }
        else {
            navigator.push = pushRef.current;
            window.onbeforeunload = null;
        }
        var pushLocalRef = pushRef.current;
        return function () {
            navigator.push = pushLocalRef;
            window.onbeforeunload = null;
        };
    }, [isBlock, navigator]);
    var handleClose = function () {
        setIsShowConfirm(false);
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    };
    var handleLeave = function () {
        onLeave === null || onLeave === void 0 ? void 0 : onLeave();
        navigator.push = pushRef.current;
        setIsShowConfirm(false);
        if (pushArgsRef.current) {
            navigator.push.apply(navigator, pushArgsRef.current);
        }
    };
    if (isShowConfirm) {
        return ((0, jsx_runtime_1.jsx)(UnsavedChangesModal_1.default, { onCancel: handleClose, onLeave: handleLeave, modalTitle: modalTitle, modalDescription: modalDescription, primaryButtonLabel: primaryButtonLabel, secondaryButtonLabel: secondaryButtonLabel }));
    }
    return null;
};
exports.default = BlockLeavePage;
